import { LANGUAGE } from '../constants';
import { Language } from '../types/common';
import type { SelectOption } from '../types/common';
import type { OptionsType } from '../types/options';

/**
 * OptionsType[]からSelectOption<T>[]を作成する。
 * @param options [OptionsType[]]
 * @param language? [Language]
 * @returns [SelectOption[]]
 */
const getOptionsSelectOptions = <T>(options: OptionsType<T>[], language?: Language): SelectOption<T>[] => {
  const selectOptions = options.map((option) => {
    const label = language ? (language === LANGUAGE.EN ? (option.nameEnglish ? option.nameEnglish : option.nameJapanese) : option.nameJapanese) : option.nameJapanese;
    const value = option.code;
    return { label, value };
  });
  return selectOptions;
};

export default getOptionsSelectOptions;
